<template>
  <div :style="customStyle" class="custom-money-container">
    <label v-if="label" :style="customLabelStyle">{{ label }}</label>
    <money
      v-bind="moneyOptions"
      v-model="localValue"
      @input="updateValue"
      :style="customInputStyle"
      class="custom-money-input"
    ></money>
  </div>
</template>

<script>
import { Money } from 'v-money';

export default {
  name: 'CustomMoney',
  components: {
    Money,
  },
  props: {
    value: {
      type: Number,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    options: {
      type: Object,
      default: () => ({
        decimal: '.',
        thousands: ',',
        prefix: '$ ',
        suffix: '',
        precision: 2,
        masked: false,
      }),
    },
    customStyle: {
      type: Object,
      default: () => ({})
    },
    customInputStyle: {
      type: Object,
      default: () => ({})
    },
    customLabelStyle: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      localValue: this.value,
      moneyOptions: this.options,
    };
  },
  watch: {
    value(newValue) {
      this.localValue = newValue;
    },
  },
  methods: {
    updateValue(event) {
      this.$emit('input', event);
    },
  },
};
</script>

<style scoped>
.custom-money-container {
  display: flex;
  flex-direction: column;
  margin-top: -20px;
  width: 170px;
}

.custom-money-container label{
  text-align: left;
  letter-spacing: 0px;
  color: #707070;
  opacity: 1;
  width: 130px;
  margin-left: 10px;
  background: white;
  position: relative;
  z-index: 2;
  top: 11px;
  padding-left: 4px;
  
}

.custom-money-input {
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px;
  font-size: 16px;
  width: 100%;
  box-sizing: border-box;
}

.custom-money-input:focus {
  border-color: #66afe9;
  outline: none;
}
</style>